export const LOG_LONG_CONTENT_PROPS = new Set(['DiagParam', 'ResData']);

export function splitLogParamPrefix(value, prop) {
  const text = value === null || value === undefined ? '' : String(value);
  if (prop !== 'DiagParam') {
    return { prefix: '', content: text };
  }

  const match = text.match(/^(sm2|pro):(.*)$/s);
  if (!match) {
    return { prefix: '', content: text };
  }

  return { prefix: match[1], content: match[2] };
}

export function decodeUnicodeEscapes(value) {
  return String(value).replace(/\\u([0-9a-fA-F]{4})/g, (_, hex) => {
    return String.fromCharCode(Number.parseInt(hex, 16));
  });
}

export function formatJsonLikeLogText(value, options = {}) {
  const { pretty = false } = options;
  const decoded = decodeUnicodeEscapes(value).trim();
  if (!decoded) return '';

  try {
    return JSON.stringify(JSON.parse(decoded), null, pretty ? 2 : 0);
  } catch (error) {
    return decoded;
  }
}

export function formatLogDisplayValue(value, prop) {
  if (value === null || value === undefined) return '';
  const raw = String(value);
  if (!LOG_LONG_CONTENT_PROPS.has(prop)) return raw;

  const { prefix, content } = splitLogParamPrefix(raw, prop);
  const formatted = formatJsonLikeLogText(content);
  return prefix ? `${prefix}:${formatted}` : formatted;
}
